"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.configureFramework = void 0;
const session_1 = require("../../session");
const authenticator_1 = require("../../authenticator");
const features_1 = require("../../features");
const storage_1 = require("../../session/cc/storage");
const store_1 = require("../../store");
const configureFramework = (modelBankUSDManager, additionalPlugins = []) => {
    const Session = new session_1.MbAssistedSession(new storage_1.MbCCSessionStorage((0, store_1.getDefaultCookiesStore)()));
    const plugins = [...additionalPlugins];
    Session.setXHR(new features_1.XHR({
        plugins,
    }));
    const AuthApi = new features_1.XHR({
        plugins: [...additionalPlugins],
    });
    const Authenticator = new authenticator_1.MbAssistedAuthenticator(Session, AuthApi, modelBankUSDManager);
    return {
        Session,
        Authenticator,
    };
};
exports.configureFramework = configureFramework;
//# sourceMappingURL=base.js.map